// extracted by mini-css-extract-plugin
export default {"linkList":"styles_linkList__bethx"};